import { ThreadsQueryThread } from "@/app/Threads/GraphQL/threadQueries";

/**
 * Where selection goes when a thread leaves the list it was read from: the row
 * below it, the row above it if it was last, `null` when the list is now empty,
 * and `undefined` when the thread isn't listed and there is no position to move
 * from — leave selection alone rather than guess at one.
 */
export function nextThreadAfter(
  threads: ThreadsQueryThread[],
  threadId: string,
): ThreadsQueryThread | null | undefined {
  const index = threads.findIndex((thread) => thread.id === threadId);

  if (index === -1) {
    return undefined;
  }

  return threads[index + 1] ?? threads[index - 1] ?? null;
}
